import { Button, Checkbox, IconButton, Input, makeStyles, MenuItem, Select } from '@material-ui/core';
import { red, teal } from '@material-ui/core/colors';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import React, {useEffect, useRef, useState} from 'react';
import { useSelector } from 'react-redux';
import { univApiCall } from '../../albCommonModule';
import SnackMsg from '../common/SnackMsg';
import { WorkShiftLinksTab } from './WorkShiftMake';

const LICENSE_LIST = ["児童発達支援責任者", "理学療法士等", "保育士", "指導員", "送迎員"];

const useStyles = makeStyles({
  workShiftSetting: {
    width: 'fit-content',
    marginTop: 112,
    marginLeft: 'auto',
    marginRight: 'auto',
    // paddingLeft: 64,
    '& .nameForm': {
      width: '12rem',
      marginRight: 8,
    },
    '& .licenseForm': {
      width: '11rem',
      margin: '0 8px',
    },
    '& .driverForm': {
      marginRight: 8
    },
    '& .confirmMsg': {
      color: 'red',
    },
    '& .formHeader': {
      display: 'flex',
      paddingBottom: 4,
      width: 'fit-content',
      borderBottom: `1px solid ${teal[800]}`,
      position: 'sticky',
      top: 80,
      '& div': {
        textAlign: 'center',
      },
      '& .driverForm': {
        width: 42
      },
      '& .confirmMsg': {
        marginTop: 8
      },
      '& .deleteButton': {
        width: 100
      }
    },
    '& .staffForm': {
      margin: '16px 0',
      '& .deleteButton': {
        width: '5rem',
        padding: '6px 8px',
        marginLeft: 16
      },
    },
    '& .buttonContainer': {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      // marginRight: 96,
      '& .confirmMsg': {
        marginRight: 8
      }
    }
  }
});

const WorkShiftSettingForm = (props) => {
  const {staffs, setStaffs, index, com, ext, setSnack} = props;
  const [toDelete, setToDelete] = useState(false);
  const [driverErr, setDriverErr] = useState(false);
  const staff = staffs[index];
  const changeName = (e) => {
    const result = [...staffs];
    result[index].name = e.target.value;
    setStaffs([...result]);
  }
  const changeLicense1 = (e) => {
    const result = [...staffs];
    result[index].license[0] = e.target.value;
    setStaffs([...result]);
    setDriverErr(false);
  }
  const changeLicense2 = (e) => {
    const result = [...staffs];
    result[index].license[1] = e.target.value;
    setStaffs([...result]);
    setDriverErr(false);
  }
  const changeLicense3 = (e) => {
    const result = [...staffs];
    result[index].license[2] = e.target.value;
    setStaffs([...result]);
    setDriverErr(false);
  }
  const changeDriver = (e) => {
    if((!staff.license.length || staff.license.every(x => x===0)) && staff.driver){
      setDriverErr(true);
      return;
    }
    const result = [...staffs];
    result[index].driver = e.target.checked;
    setStaffs([...result]);
  }
  const handleDelete = () => {
    if(!toDelete){
      setToDelete(true);
      return;
    }
    const result = [...staffs];
    result.splice(index, 1);
    ext.staffs = result;
    const prms = {
      a: "sendComExt",
      hid: com.hid,
      bid: com.bid,
      ext: JSON.stringify({...ext})
    }
    univApiCall(prms, '', '', setSnack, "削除しました。", "削除に失敗");
    setStaffs([...result]);
    setToDelete(false);
  }
  return(
    <div className='staffForm'>
      <Input
        value={staff.name}
        className="nameForm"
        onChange={changeName}
      />
      <Select
        label="役職１"
        value={staff.license[0] ?staff.license[0] :0}
        className="licenseForm"
        onChange={changeLicense1}
      >
        <MenuItem value={0}>役職を選択</MenuItem>
        {LICENSE_LIST.map(license => {
          if(staff.license[1]===license || staff.license[2]===license) return null;
          return(
            <MenuItem value={license}>{license}</MenuItem>
          )
        })}
      </Select>
      <Select
        label="役職２"
        value={staff.license[1] ?staff.license[1] :0}
        className="licenseForm"
        onChange={changeLicense2}
      >
        <MenuItem value={0}>役職を選択</MenuItem>
        {LICENSE_LIST.map(license => {
          if(staff.license[0]===license || staff.license[2]===license) return null;
          return(
            <MenuItem value={license}>{license}</MenuItem>
          )
        })}
      </Select>
      <Select
        label="役職３"
        value={staff.license[2] ?staff.license[2] :0}
        className="licenseForm"
        onChange={changeLicense3}
      >
        <MenuItem value={0}>役職を選択</MenuItem>
        {LICENSE_LIST.map(license => {
          if(staff.license[0]===license || staff.license[1]===license) return null;
          return(
            <MenuItem value={license}>{license}</MenuItem>
          )
        })}
      </Select>
      <Checkbox
        checked={staff.driver}
        className="driverForm"
        onChange={changeDriver}
      />
      <Button
        variant='contained'
        className='deleteButton'
        style={toDelete ?{backgroundColor: red[600], color: 'white'} :{}}
        onClick={handleDelete}
      >
        {toDelete ?"削除実行" :"削除"}
      </Button>
      {driverErr ?<div className='confirmMsg'>送迎をオフにする場合は、役職を１つ以上与える必要があります。</div> :null}
      {!staff.driver && staff.license.every(x => x===0)
        ?<div className='confirmMsg'>役職がない場合は、送迎をオンにしてください。</div>
        :null}
    </div>
  )
}

const WorkShiftSetting = () => {
  const classes = useStyles();
  const allState = useSelector(state => state);
  const ref = useRef(true);
  const com = allState.com ?allState.com :{};
  const ext = com.ext ?com.ext :{};
  const initDt = {name: "", license: [], driver: true};
  const [staffs, setStaffs] = useState(
    ext.staffs ?ext.staffs.length ?[...ext.staffs] :[initDt] :[initDt]
  );
  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (ref.current) {
      ref.current = false;
      return;
    }
    const errs = {...errors};
    if(staffs.some(staffDt => staffDt.name === "")){
      errs["nonName"] = true;
    }else{
      errs["nonName"] = false;
    }
    if(staffs.some(staffDt => staffDt.license.every(x => x===0) && !staffDt.driver)){
      errs["nonLicenseOffDriver"] = true;
    }else{
      errs["nonLicenseOffDriver"] = false;
    }
    if(staffs.some(staffDt => staffs.filter(x => x.name === staffDt.name).length>=2)){
      errs["sameName"] = true;
    }else{
      errs["sameName"] = false;
    }
    setErrors({...errs});
  }, [staffs])
  const [snack, setSnack] = useState({});
  const addForm = () => {
    const dtList = [...staffs];
    dtList.push(initDt);
    setStaffs([...dtList]);
    ref.current = true;
  }
  const handleClick = () => {
    const errs = {...errors};
    if(staffs.some(staffDt => staffDt.name === "")){
      errs["nonName"] = true;
      setErrors({...errs});
      return;
    }else if(staffs.some(staffDt => staffDt.license.every(x => x===0) && !staffDt.driver)){
      errs["nonLicenseOffDriver"] = true;
      setErrors({...errs});
      return;
    }
    else if(staffs.some(staffDt => staffs.filter(x => x.name === staffDt.name).length>=2)){
      errs["sameName"] = true;
      setErrors({...errs});
      return;
    }
    ext.staffs = staffs;
    const prms = {
      a: "sendComExt",
      hid: com.hid,
      bid: com.bid,
      ext: JSON.stringify({...ext})
    }
    univApiCall(prms, '', '', setSnack, "書き込みました。", "書き込みに失敗しました。");
  }
  const formNodes = staffs.map((_, i) => {
    const parms = {staffs, setStaffs, index: i, com, ext, setSnack};
    return <WorkShiftSettingForm key={i} {...parms}/>
  });

  return(
    <>
    <WorkShiftLinksTab />
    <div className={classes.workShiftSetting}>
      <div className="formHeader">
        <div className='nameForm'>氏名</div>
        <div className='licenseForm'>役職１</div>
        <div className='licenseForm'>役職２</div>
        <div className='licenseForm'>役職３</div>
        <div className='driverForm'>送迎</div>
        <div className='deleteButton'></div>
      </div>
      {formNodes}
      <IconButton
        onClick={addForm}
      >
        <AddCircleOutlineIcon
          style={{color: teal[800]}}
          fontSize="large"
        />
      </IconButton>
      <div className='buttonContainer'>
        <div className='confirmMsg'>{(() => {
          let result = "";
          if(errors.nonName) result = "氏名が入力されていない項目があります。";
          else if(errors.nonLicenseOffDriver) result = "役職・送迎を１つ以上選択してください。";
          else if(errors.sameName) result = "同名スタッフは登録できません。";
          return result
        })()}</div>
        <Button
          color='primary'
          variant='contained'
          disabled={Object.values(errors).some(x => x)}
          onClick={handleClick}
        >
          書き込み
        </Button>
      </div>
    </div>
    <SnackMsg {...snack} />
    </>
  )
}
export default WorkShiftSetting